import React from 'react';
import Styles from './lifetime-earnings-styles.scss';
import CashButton from '../cash-button/cash-button';
import { parseNumberMoney } from '@/presentation/utils/number-utils';
import { CircleSpinner } from '..';
const LifetimeEarnings = ({ totalEarnings = 0, status = 'locked', onClickAction, TOTAL_EARNINGS_TO_CASHOUT, TOTAL_USD, paying = false }) => {
    const showExtraText = () => {
        if (status === 'locked' || status === 'cash') {
            return (React.createElement("p", { className: Styles.extra },
                "Earn your one-time ",
                parseNumberMoney(TOTAL_USD),
                " USD cash reward after reaching ",
                React.createElement("br", null),
                ' ',
                parseNumberMoney(TOTAL_EARNINGS_TO_CASHOUT),
                " KV Bucks"));
        }
    };
    const handleClicked = () => {
        if (status === 'cash' && onClickAction) {
            onClickAction();
        }
    };
    const buttonText = status === 'claimed'
        ? `${parseNumberMoney(TOTAL_USD)} USD Obtained`
        : `Cash Out Your ${parseNumberMoney(TOTAL_USD)} USD`;
    return (React.createElement("div", { className: Styles.lifetimeEarningsContainer },
        React.createElement("h3", { className: Styles.title }, "Lifetime Earnings"),
        React.createElement("div", { className: Styles.content },
            React.createElement("h3", { className: Styles.subtitle }, "Lifetime Earnings"),
            React.createElement("h2", { className: Styles.value },
                parseNumberMoney(totalEarnings),
                " KV"),
            React.createElement("div", { className: Styles.button }, paying ? React.createElement(CircleSpinner, null) : React.createElement(CashButton, { type: status, text: buttonText, onClick: handleClicked })),
            showExtraText())));
};
export default LifetimeEarnings;
